<template>
    <div class="ReferralOperations" v-if="RecordData.Id">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <h2 class="underline bold">Timeline</h2>
                    <!--INQUIRY STARTED-->
                    <div class="row referral-timeline-container">
                        <div class="col">
                            <h4>INQUIRY:</h4>
                            <div class="referral-timeline">
                                <p><span class="bold">DATE:</span> {{formatDate(RecordData.InquiryDateTime)}}</p>
                            </div>
                        </div>
                    </div>
                    <!--INQUIRY CLOSED-->
                    <div class="row referral-timeline-container" v-if="ReferralStatus == 'Inquiry Closed'">
                        <div class="col">
                            <h4>INQUIRY CLOSED:</h4>
                            <div class="referral-timeline">
                                <p><span class="bold">DATE:</span> {{formatDate(RecordData.InquiryDispositionDate)}}</p>
                                <p><span class="bold">REASON:</span> {{RecordData.InquiryDisposition}}</p>
                                <p><span class="bold">COMMENTS:</span> {{RecordData.InquiryDispositionComments}}</p>
                            </div>
                        </div>
                    </div>
                    <!--ENGAGEMENT STARTED-->
                    <div class="row referral-timeline-container" v-if="RecordData.EngagementDate != null">
                        <div class="col">
                            <h4>ENGAGEMENT OPENED:</h4>
                            <div class="referral-timeline">
                                <p><span class="bold">DATE:</span> {{formatDate(RecordData.EngagementDate)}}</p>
                            </div>
                        </div>
                    </div>
                    <!--ENGAGEMENT CLOSED-->
                    <div class="row referral-timeline-container" v-if="RecordData.EngagementDispositionDate != null">
                        <div class="col">
                            <h4>ENGAGEMENT CLOSED:</h4>
                            <div class="referral-timeline">
                                <p><span class="bold">DATE:</span> {{formatDate(RecordData.EngagementDispositionDate)}}</p>
                                <p><span class="bold">REASON:</span> {{RecordData.EngagementDisposition}}</p>
                                <p><span class="bold">COMMENTS:</span> {{RecordData.EngagementDispositionComments}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <h2 class="underline bold">Operations</h2>
                    <p v-if="this.RecordData.CommunityFamilyID == null">
                        <i class="fa fa-exclamation red" /> Looking to Open an Engagement here?  This Inquiry has not been assigned to a Community Family yet, so an Engagement can not be opened.  First Assign this to a Family (or Create one) and then return to this Pane.
                    </p>
                    <div v-if="ReferralStatus != 'Hosting In Progress'">
                        <!--OPEN INQUIRY-->
                        <!--Close Inquiry-->
                        <div class="referral-operation-action" v-if="ReferralStatus == 'Inquiry With No Community Family'">
                            <b-button size="md" variant="warning" type="button" class="form-control" @click="ShowCloseInquiry">
                                <i class="fa fa-minus" /> CLOSE INQUIRY / HELPLINE CALL
                            </b-button>
                        </div>

                        <!--Delete Inquiry-->
                        <div class="referral-operation-action" v-if="ReferralStatus == 'Inquiry With No Community Family'">
                            <b-button size="md" variant="danger" type="button" class="form-control" @click="ShowDeleteInquiry()">
                                <i class="fa fa-trash" /> DELETE INQUIRY / HELPLINE CALL
                            </b-button>
                        </div>

                        <!--OPEN INQUIRY AND ASSIGNED COMMUNITY FAMILY-->
                        <!--Open Engagement-->
                        <div class="referral-operation-action" v-if="ReferralStatus == 'Open Inquiry'">
                            <b-button size="md" variant="success" type="button" class="form-control" @click="ShowOpenEngagement">
                                <i class="fa fa-plus" /> OPEN ENGAGEMENT
                            </b-button>
                        </div>

                        <!--Close Inquiry-->
                        <div class="referral-operation-action" v-if="ReferralStatus == 'Open Inquiry'">
                            <b-button size="md" variant="warning" type="button" class="form-control" @click="ShowCloseInquiry">
                                <i class="fa fa-minus" /> CLOSE INQUIRY / HELPLINE CALL
                            </b-button>
                        </div>

                        <!--RE-Open INQUIRY-->
                        <div class="referral-operation-action" v-if="ReferralStatus == 'Inquiry Closed'">
                            <b-button size="md" variant="danger" type="button" class="form-control" @click="ShowReopenInquiry()">
                                <i class="fa fa-plus" /> RE-OPEN INQUIRY
                            </b-button>
                        </div>

                        <!--Delete Inquiry-->
                        <div class="referral-operation-action" v-if="ReferralStatus == 'Open Inquiry'">
                            <b-button size="md" variant="danger" type="button" class="form-control" @click="ShowDeleteInquiry()">
                                <i class="fa fa-trash" /> DELETE INQUIRY / HELPLINE CALL
                            </b-button>
                        </div>


                        <!--CLOSE ENGAGEMENT-->
                        <div class="referral-operation-action" v-if="ReferralStatus == 'Open Engagement'">
                            <b-button size="md" variant="warning" type="button" class="form-control" @click="ShowCloseEngagement()">
                                <i class="fa fa-minus" /> CLOSE ENGAGEMENT
                            </b-button>
                        </div>

                        <!--CANCEL ENGAGEMENT-->
                        <div class="referral-operation-action" v-if="ReferralStatus == 'Open Engagement'">
                            <b-button size="md" variant="danger" type="button" class="form-control" @click="ShowCancelEngagement()">
                                <i class="fa fa-trash" /> CANCEL ENGAGEMENT
                            </b-button>
                        </div>

                        <!--ReOpen Engagement-->
                        <div class="referral-operation-action" v-if="ReferralStatus == 'Engagement Closed'">
                            <b-button size="md" variant="danger" type="button" class="form-control" @click="ShowReopenEngagement()">
                                <i class="fa fa-plus" /> RE-OPEN ENGAGEMENT
                            </b-button>
                        </div>
                    </div>
                    <div v-else>
                        <i class="fa fa-exclamation red" /> There are one or more Hostings in Progress.  While Hostings are Occuring, you can not perform any operations on this Record.
                    </div>


                </div>
            </div>
        </div>

        <!--MODALS-->
        <!--Close Inquiry-->
        <b-modal ref="modal-close-inquiry" title="Close Inquiry" hide-footer>
            <b-container>
                <b-form @submit="SaveCloseInquiry">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Inquiry Closure Date:</label>
                                <flat-pickr v-model="EffectiveDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Closure Reason:</label>
                                <select type="text" v-model="Reason" class="form-control" required>
                                    <option value="Referred to another Olive Crest Program">Referred to another Olive Crest Program</option>
                                    <option value="Referred to an Outside Resource">Referred to an Outside Resource</option>
                                    <option value="Family Withdrew Request for Help">Family Withdrew Request for Help</option>
                                    <option value="Caregiver not Available to Provide Consent">Caregiver not Available to Provide Consent</option>
                                    <option value="Family could not be Reached">Family could not be Reached</option>

                                    <option value="Other">Other (please add detailed comment)</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Comments on Inquiry Closure:</label>
                                <textarea rows="5" v-model="Comments" class="form-control"></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <h3>What Am I Doing?</h3>
                        <p>Closing an Inquiry means that a Hosting will not be attempted with this Family, and you are ending their encounter with Olive Crest (for now at least).  If the Family returns in the future, a new Inquiry can be started for them.</p>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelCloseInquiry()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="warning" type="submit">
                                CLOSE INQUIRY
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--Delete Inquiry-->
        <b-modal ref="modal-delete-inquiry" title="Delete Inquiry / Helpline Call" hide-footer>
            <b-container>
                <b-form @submit="SaveDeleteInquiry">
                    <b-row>
                        <h3 class="red">WARNING</h3>
                        <p>You are about to DELETE this Inquiry / Helpline Call.  This makes it as if this entire inquiry record never existed, and you will be returned to the Inquiry List.  This is typically only done if an Inquiry was added by Mistake.  This will NOT delete any Community Family connected to this Inquiry.  If you also need to delete a Community Family, go to the Community Family's profile and delete from there.'</p>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelDeleteInquiry()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="danger" type="submit">
                                DELETE INQUIRY
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--Open Engagement-->
        <b-modal ref="modal-open-engagement" title="Open Engagement" hide-footer>
            <b-container>
                <b-form @submit="SaveOpenEngagement">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Engagement Open Date:</label>
                                <flat-pickr v-model="EffectiveDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <h3>What Am I Doing?</h3>
                        <p>Opening an Engagment means that you intend to find a Hosting for this Community Family.  This starts the process of finding a suitable family.  If this Inquiry is not appropriate for Hosting, Close the Inquiry instead of Opening an Engagement.</p>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelOpenEngagement()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                OPEN ENGAGEMENT
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--Close Engagement-->
        <b-modal ref="modal-close-engagement" title="Close Engagement" hide-footer>
            <b-container>
                <b-form @submit="SaveCloseEngagement">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Engagement Closure Date:</label>
                                <flat-pickr v-model="EffectiveDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Closure Reason:</label>
                                <select type="text" v-model="Reason" class="form-control" required>
                                    <option value="Hosting Ended: Successfully">Hosting Ended: Successfully</option>

                                    <option value="Hosting Ended: Behavioral Issues">Hosting Ended: Behavioral Issues</option>
                                    <option value="Hosting Ended: Legal Issues">Hosting Ended: Legal Issues</option>
                                    <option value="Hosting Ended: Medical Issues">Hosting Ended: Medical Issues</option>
                                    <option value="Hosting Ended: Child(ren) Detained">Hosting Ended: Child(ren) Detained</option>
                                    <option value="Hosting Ended: Child(ren) Entered Foster Care">Child(ren) Entered Foster Care</option>
                                    <option value="Hosting Ended: Child(ren) Runaway">Hosting Ended: Child(ren) Runaway</option>

                                    <option value="Hosting could not be Achieved">Hosting could not be Achieved</option>

                                    <option value="Other">Other (please add detailed comment)</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Comments on Engagement Closure:</label>
                                <textarea rows="5" v-model="Comments" class="form-control"></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <h3>What Am I Doing?</h3>
                        <p>Closing an Engagement means that Olive Crest's current Encounter with this Family has ended.  If the Family returns in the future, a new Inquiry can be started.</p>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelCloseEngagement()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="warning" type="submit">
                                CLOSE ENGAGEMENT
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--Cancel Engagement-->
        <b-modal ref="modal-cancel-engagement" title="Cancel Engagement" hide-footer>
            <b-container>
                <b-form @submit="SaveCancelEngagement">
                    <b-row>
                        <h3 class="red">WARNING</h3>
                        <p>You are about to CANCEL this Enngagement.  This will return this record back to a status of INQUIRY, and makes it as if the Engagement was never started.  This is typically only done when an Engagement was Opened by Mistake.</p>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelCancelEngagement()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="danger" type="submit">
                                CANCEL ENGAGEMENT
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--Re-Open Inquiry-->
        <b-modal ref="modal-reopen-inquiry" title="Re-Open Inquiry" hide-footer>
            <b-container>
                <b-form @submit="SaveReopenInquiry">
                    <b-row>
                        <h3 class="red">WARNING</h3>
                        <p>You are about to RE-OPEN this Inquiry.  This will make it as if the Inquiry was never closed.  This is typically only done when an Inquiry was Closed by Mistake.</p>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelReopenInquiry()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="danger" type="submit">
                                RE-OPEN INQUIRY
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--Re-Open Engagement-->
        <b-modal ref="modal-reopen-engagement" title="Re-Open Engagement" hide-footer>
            <b-container>
                <b-form @submit="SaveReopenEngagement">
                    <b-row>
                        <h3 class="red">WARNING</h3>
                        <p>You are about to RE-OPEN this Engagement.  This will make it as if the Engagement was never closed.  This is typically only done when an Engagement was Closed by Mistake.</p>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelReopenEngagement()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="danger" type="submit">
                                RE-OPEN ENGAGEMENT
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //Import Components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    
    //Import Services
    import { EventBus } from '../../../../../services/event-bus.js';

    export default {
        name: "ReferralOperations",
        props: [
            'RecordData',
            
        ],
        data: function () {
            return {
                //API DATA
                EffectiveDate: null,
                Reason: null,
                Comments: null,
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y'
                },
            }
        },
        methods: {
            //CLOSE INQUIRY
            ShowCloseInquiry() {
                this.ResetFormValues();
                this.$refs['modal-close-inquiry'].show()
            },
            CancelCloseInquiry() {
                this.$refs['modal-close-inquiry'].hide()
            },
            SaveCloseInquiry(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("PATCH", "StrongFamilies/Referrals/Operations/CloseInquiry", { Id: this.RecordData.Id, EffectiveDate: this.EffectiveDate, Reason: this.Reason, Comments: this.Comments }, this.SaveOperationSuccess, () => { }, true);
            },
            //DELETE INQUIRY
            ShowDeleteInquiry() {
                this.ResetFormValues();
                this.$refs['modal-delete-inquiry'].show()
            },
            CancelDeleteInquiry() {
                this.$refs['modal-delete-inquiry'].hide()
            },
            SaveDeleteInquiry(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("PATCH", "StrongFamilies/Referrals/Operations/DeleteInquiry", { Id: this.RecordData.Id, EffectiveDate: this.EffectiveDate, Reason: this.Reason, Comments: this.Comments }, this.DeleteInquirySuccess, () => { }, true);
            },
            //RE-OPEN INQUIRY
            ShowReopenInquiry() {
                this.ResetFormValues();
                this.$refs['modal-reopen-inquiry'].show()
            },
            CancelReopenInquiry() {
                this.$refs['modal-reopen-inquiry'].hide()
            },
            SaveReopenInquiry(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("PATCH", "StrongFamilies/Referrals/Operations/ReopenInquiry", { Id: this.RecordData.Id, EffectiveDate: this.EffectiveDate, Reason: this.Reason, Comments: this.Comments }, this.SaveOperationSuccess, () => { }, true);
            },

            //OPEN ENGAGEMENT
            ShowOpenEngagement() {
                this.ResetFormValues();
                this.$refs['modal-open-engagement'].show()
            },
            CancelOpenEngagement() {
                this.$refs['modal-open-engagement'].hide()
            },
            SaveOpenEngagement(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("PATCH", "StrongFamilies/Referrals/Operations/OpenEngagement", { Id: this.RecordData.Id, EffectiveDate: this.EffectiveDate, Reason: this.Reason, Comments: this.Comments }, this.SaveOperationSuccess, () => { }, true);
            },
            //CLOSE ENGAGEMENT
            ShowCloseEngagement() {
                this.ResetFormValues();
                this.$refs['modal-close-engagement'].show()
            },
            CancelCloseEngagement() {
                this.$refs['modal-close-engagement'].hide()
            },
            SaveCloseEngagement(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("PATCH", "StrongFamilies/Referrals/Operations/CloseEngagement", { Id: this.RecordData.Id, EffectiveDate: this.EffectiveDate, Reason: this.Reason, Comments: this.Comments }, this.SaveOperationSuccess, () => { }, true);
            },

            //CANCEL ENGAGEMENT
            ShowCancelEngagement() {
                this.ResetFormValues();
                this.$refs['modal-cancel-engagement'].show()
            },
            CancelCancelEngagement() {
                this.$refs['modal-cancel-engagement'].hide()
            },
            SaveCancelEngagement(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("PATCH", "StrongFamilies/Referrals/Operations/CancelEngagement", { Id: this.RecordData.Id, EffectiveDate: this.EffectiveDate, Reason: this.Reason, Comments: this.Comments }, this.SaveOperationSuccess, () => { }, true);
            },
            //RE-OPEN ENGAGEMENT
            ShowReopenEngagement() {
                this.ResetFormValues();
                this.$refs['modal-reopen-engagement'].show()
            },
            CancelReopenEngagement() {
                this.$refs['modal-reopen-engagement'].hide()
            },
            SaveReopenEngagement(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("PATCH", "StrongFamilies/Referrals/Operations/ReopenEngagement", { Id: this.RecordData.Id, EffectiveDate: this.EffectiveDate, Reason: this.Reason, Comments: this.Comments }, this.SaveOperationSuccess, () => { }, true);
            },

            //SAVE OPERATION SUCCESS
            SaveOperationSuccess(response) {
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.RecordData.Id);

                this.CancelCloseInquiry()                
                this.CancelReopenInquiry()
                this.CancelOpenEngagement()
                this.CancelCloseEngagement()
                this.CancelCancelEngagement()
                this.CancelReopenEngagement()
            },
            DeleteInquirySuccess(response) {
                this.CancelDeleteInquiry();
                this.$parent.$parent.ResetSelection();

            },
            //AUX
            ResetFormValues() {
                this.EffectiveDate = null;
                this.Reason = null;
                this.Comments = null;
            },
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
        },
        components: {
            flatPickr
        },
        mounted() {
        },
        computed: {
            ReferralStatus: function () {
                if (this.RecordData.CommunityFamilyID == null && this.RecordData.InquiryDispositionDate == null) {
                    return "Inquiry With No Community Family"
                }
                else {
                    return this.RecordData.Status;
                }
            }
        }
    }
</script>

<style scoped>
</style>